// extracted by mini-css-extract-plugin
export default {"cardIcon":"_1ejSQc-CovV39pQy3-bT7a"};